<template>
  <el-drawer v-model="showDrawer"
    direction="ttb"
    size="450px"
    style="width: 40%; left: 30%; top: 140px;"
    @close="closeDrawer"
    :with-header="noHeader"
    show-close
    >

    <!-- <template #header style="display: flex; justify-content: center; margin-bottom: 0px;">
      <div class="title-text">
      Contact us
      </div>
    </template> -->
    <template #default>
      <div class="title-text">
      Contact us
      </div>
      <div class="contac-qrcode">
        <div style="width: 300px; height: 300px;">
        <el-image :src="require('@/assets/contact.png')"
        fit='cover'
        :preview-src-list="srcList"/>
        </div>
      </div>
      <div>
        Send email to: <el-text type="primary"><span style="font-size: 20px;">kingwood@global-ptt.com</span></el-text>
      </div>
    </template>
  </el-drawer>
</template>

<script setup>
import {ref, computed, defineProps, defineEmits } from 'vue'
const props = defineProps(['show'])
const emits = defineEmits(['close'])
const showDrawer = computed({
  get() {
    return props['show']
  },
  set(val) {
    return val
  }
})
const srcList=[
  require('@/assets/contact.png')
]
const closeDrawer = ()=>{
  console.log('close')
  emits('close')
  showDrawer.value=false
}

const noHeader = ref(false)
</script>
<style scoped>
.contac-qrcode{
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 10px 0px 15px 0px;
}
.title-text {
  font-size: 2rem;
  color: Black;
}
:deep(.el-drawer__header) {
  font-size: 200px;
}

</style>